<footer>
	<p>
		Produced by students of the Media Innovation masters' program at the <a
			href="https://camd.northeastern.edu/journalism-at-northeastern/"
			style="text-decoration: underline">Northeastern University School of Journalism.</a
		> &#169; 2021
	</p>
  <a href="https://mediainnovation.camd.northeastern.edu/2021/masters/" target="_blank">
    <img
        src="https://mediainnovation.camd.northeastern.edu/2021/loveinthetimeofcovid/images/seal_logotype-768x252.png"
        width="300px"
        alt="Logo of Northeastern University College of Arts, Media and Design"
    />
  </a>
</footer>

<style>
  footer {
    font-size: 0.8em;
    text-align: center;
    max-width: 90%;
    margin: 0 auto 20px;
    font-family: 'Fira Sans Condensed', sans-serif;
  }
</style>
